import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useState, useEffect, useContext, useRef } from "react";
import { useTranslation } from "react-i18next";
import "../../css/wallet/wallet.css";

import { AuthContext } from "../SessionChecker/SessionChecker.js";
import { ConvertDollarToToman } from "./Convert/ConvertDollarToToman.js";
import { WalletContext } from "./WalletProvider.js";
import WalletLoading from "./WalletLoading.js";

function Wallet({ theme }) {
  const { inactiveWalletMessage, tokensInfo, trxAPIData, requestStatus } =
    useContext(WalletContext);

  // convert dollar to toman
  const [tomanValue, setTomanValue] = useState(0);
  const prevTomanValueRef = useRef(0);
  const [updatingTomanValueStatus, setUpdatingTomanValueStatus] =
    useState(false);
  const [tomanValueColor, setTomanValueColor] = useState(null);

  const navigate = useNavigate();

  const { t } = useTranslation();

  const {
    sessionStatus,
    currentUserUsername,
    tick,
    authenticationStatus,
    setEmailConfirmStatus,
    emailStatus,
  } = useContext(AuthContext);

  const prices = {
    TRX: Number(trxAPIData?.c || 0),
    USDT: 1,
  };

  useEffect(() => {
    document.title = t("Hiket, Home");

    let interval;

    if (sessionStatus == true) {
      ConvertDollarToToman(
        setTomanValue,
        prevTomanValueRef,
        setTomanValueColor,
        setUpdatingTomanValueStatus,
      );
      interval = setInterval(() => {
        ConvertDollarToToman(
          setTomanValue,
          prevTomanValueRef,
          setTomanValueColor,
          setUpdatingTomanValueStatus,
        );
      }, 600000);
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [sessionStatus, tokensInfo, t]);

  useEffect(() => {}, [trxAPIData]);

  return (
    <div className="mainDiv">
      <div className={`headerDiv ${theme}`}>
        {sessionStatus ? (
          <>
            <>
              <div>{currentUserUsername}</div>
              {tick == true ? (
                <div className="tickDiv">
                  <img src="/icons/green_tick.png"></img>
                </div>
              ) : null}
            </>
            <div className="empty_center_div"></div>
            <button
              className="iconButton"
              onClick={() => {
                navigate("/history");
              }}
            >
              <img src="/icons/history.png"></img>
            </button>
          </>
        ) : (
          <button
            className="signinButton"
            onClick={() => {
              navigate("/signin");
            }}
          >
            {t("Signin")}
          </button>
        )}
      </div>

      {sessionStatus && inactiveWalletMessage && (
        <div className={`inactiveWalletMessageDiv ${theme}`}>
          {inactiveWalletMessage}
        </div>
      )}

      <div className={`contentDiv ${inactiveWalletMessage && "calc_180"}`}>
        {requestStatus ? (
          <WalletLoading theme={theme}></WalletLoading>
        ) : (
          <>
            <div className="kfjjei34d">
              {sessionStatus && !authenticationStatus && !tick && (
                <div className="kiro3ifde">
                  <img src="/icons/exclamation.png"></img>

                  <div
                    className="fderee3es"
                    onClick={() => {
                      navigate("/authentication");
                    }}
                  >
                    {t("Complate your authentication")}
                  </div>
                </div>
              )}

              {sessionStatus && !emailStatus && !tick && (
                <div
                  className="kiro3ifde"
                  onClick={() => {
                    setEmailConfirmStatus(true);
                  }}
                >
                  <img src="/icons/exclamation.png"></img>
                  <div className="fderee3es">{t("Confirm your email")}</div>
                </div>
              )}
            </div>

            {sessionStatus && (
              <div className="walletBalanceDiv">
                <div className="usdtBalanceDiv"></div>
                <div
                  className={`tomanValueDiv ${tomanValueColor === "increase" ? "increase" : tomanValueColor === "shortage" ? "shortage" : ""}`}
                >
                  {tomanValue > 0 && tomanValue.toLocaleString("en-US")}{" "}
                  {t("Toman")}
                  {updatingTomanValueStatus && (
                    <img
                      src="/icons/loading.png"
                      className={`icon rotate ${theme}`}
                    ></img>
                  )}
                </div>
              </div>
            )}

            <div className="tokensDiv">
              {tokensInfo[1]?.map((token, index) => {
                return (
                  <div
                    className="tokenDiv"
                    key={index}
                    onClick={() => {
                      navigate("/token/" + token.symbol.toLowerCase());
                    }}
                  >
                    <img src={token.logo}></img>

                    <div className="tokenInfoDiv">
                      <div className="tokenSymbolAndNameDiv">
                        <div className="tokenSymbolDiv">{token.symbol}</div>
                        <div className={`tokenNameDiv ${theme}`}>
                          {t(token.name)}
                        </div>
                      </div>

                      <div className="priceAndChangeDiv">
                        <div className={`priceDiv ${theme}`}>
                          {token.symbol == "USDT" && 1 + " $"}
                          {token.symbol == "TRX" &&
                            trxAPIData &&
                            Number(trxAPIData.c).toLocaleString("en-US") + " $"}
                          {token.symbol == "T" &&
                            Number(tokensInfo[0]?.[0]?.toman_value).toLocaleString(
                              "en-US",
                            ) + " $"}
                        </div>

                        

                        <div
                          className={`changeDiv ${theme} ${
                            token.symbol == "TRX" &&
                            trxAPIData?.P?.includes("-")
                              ? "minus"
                              : "positive"
                          }`}
                        >
                          {token.symbol == "USDT" && 0}
                          {token.symbol == "TRX" &&
                            trxAPIData &&
                            trxAPIData.P + "%"}
                        </div>
                      </div>
                    </div>

                    {sessionStatus && (
                      <div className="tokenBalanceDiv">
                        <div className="tokenBalanceDiv2">
                          {token.balance.toLocaleString("en-US")}
                        </div>
                        <div className={`tokenBalanceDiv3 ${theme}`}>
                          {token.symbol == "USDT" &&
                            (token.balance * 1).toLocaleString("en-US") + " $"}
                          {token.symbol == "TRX" &&
                            trxAPIData &&
                            (token.balance * trxAPIData.c).toLocaleString(
                              "en-US",
                            ) + " $"}

                          {token.symbol == "T" &&
                            tokensInfo[0]?.[0]?.balance_value.toLocaleString(
                              "en-US",
                            ) + " $"}
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default Wallet;
